import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";

export default function NotFound() {
  const { user, isLoading } = useAuth();
  
  // Don't render 404 during auth loading to prevent flash
  if (isLoading || user === undefined) {
    return null;
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-muted/50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-foreground">Page Not Found</h1>
          </div>

          <p className="mt-4 text-sm text-muted-foreground">
            The page you are looking for does not exist.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
